// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IQjwSqqpV3QgwbdK {
  max-width: 1310px;
  margin: 0 auto;
  padding-bottom: 96px;
}

.ZQXWt7PomsAN7ejl {
  margin: 45px 0 30px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.ZQXWt7PomsAN7ejl h2 {
  color: #303030;
  font-size: 30px;
  font-weight: 600;
  margin: 0;
}

.FyfxsZ43n3omJDP1 {
  display: flex;
  align-items: center;
  gap: 16px;
}

.bw7mvfvtVfsiYel1 {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  border: none;
  background-color: #f2e1bc;
  color: #303030;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.bw7mvfvtVfsiYel1 i {
  font-size: 16px;
}

.bw7mvfvtVfsiYel1:hover {
  background-color: #e7d2a3;
}

.LZSQqPIeccKqvgj7 {
  background-color: #f3f5f7;
  border-radius: 16px;
  padding: 30px;
  max-width: 720px;
  margin: 0 auto;
}

.LZSQqPIeccKqvgj7 .field label {
  font-size: 20px !important;
  font-weight: 400 !important;
}

.SPdU9ElWjBIq__bp {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.cPxoMG0Lh5oykh9U {
  margin-top: 36px;
  padding-top: 28px;
  border-top: 1px solid #e2e6ea;
}

@media screen and (max-width: 768px) {
  .LZSQqPIeccKqvgj7 .field {
    margin-bottom: 12px;
  }
}

@media screen and (max-width: 425px) {
  .ZQXWt7PomsAN7ejl h2 {
    font-size: 20px;
    font-weight: 700;
  }

  .LZSQqPIeccKqvgj7 {
    padding: 20px;
  }

  .LZSQqPIeccKqvgj7 .field {
    margin-bottom: 8px;
  }

  .LZSQqPIeccKqvgj7 .field label {
    font-size: 14px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EntityFormPage/EntityFormPage.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".formPage {\r\n  max-width: 1310px;\r\n  margin: 0 auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.formPageHeader {\r\n  margin: 45px 0 30px 0;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.formPageHeader h2 {\r\n  color: #303030;\r\n  font-size: 30px;\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n.titleWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.backBtn {\r\n  width: 44px;\r\n  height: 44px;\r\n  flex-shrink: 0;\r\n  border-radius: 12px;\r\n  border: none;\r\n  background-color: #f2e1bc;\r\n  color: #303030;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.backBtn i {\r\n  font-size: 16px;\r\n}\r\n\r\n.backBtn:hover {\r\n  background-color: #e7d2a3;\r\n}\r\n\r\n.formCard {\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px;\r\n  padding: 30px;\r\n  max-width: 720px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.formCard :global(.field) label {\r\n  font-size: 20px !important;\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.formFooter {\r\n  margin-top: 24px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.afterFooter {\r\n  margin-top: 36px;\r\n  padding-top: 28px;\r\n  border-top: 1px solid #e2e6ea;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .formCard :global(.field) {\r\n    margin-bottom: 12px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 425px) {\r\n  .formPageHeader h2 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .formCard {\r\n    padding: 20px;\r\n  }\r\n\r\n  .formCard :global(.field) {\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .formCard :global(.field) label {\r\n    font-size: 14px !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var formPage = `IQjwSqqpV3QgwbdK`;
export var formPageHeader = `ZQXWt7PomsAN7ejl`;
export var titleWrapper = `FyfxsZ43n3omJDP1`;
export var backBtn = `bw7mvfvtVfsiYel1`;
export var formCard = `LZSQqPIeccKqvgj7`;
export var formFooter = `SPdU9ElWjBIq__bp`;
export var afterFooter = `cPxoMG0Lh5oykh9U`;
export default ___CSS_LOADER_EXPORT___;
